import { generateColorSteps } from './design.base';

import * as colors from '../../theme/design.const';

/**
 * @typedef {DesignConfigLGeneral & OverrideConfig} OverridenConfig
 */
/**
 * @typedef {Object.<string, OverridenConfig>} DesignConfigAll
 */
/**
 * @typedef {{
 *      text2Color: string,
 *      successColor: string,
 *      primaryTint: ColorSteps,
 *      primaryColor: string, screen: {small: string, tablet: string, desktop: string, mobile: string, widescreen: string, ldesktop: string, laptop: string},
 *      baseBgColor: string,
 *      bgDefaultButton: string,
 *      borderColor: string,
 *      fontSize: {sm: number, base: number},
 *      textColor: string,
 *      mainBgColor: string,
 *      antd: ThemeConfig,
 *      browserThemeColor: string,
 *      secondaryColor: string
 * }} DesignConfigLGeneral
 */
export const DesignConfigLight = {
	primaryColor: colors.PRIMARY_COLOR,
	primaryTint: generateColorSteps(colors.PRIMARY_COLOR, 9),
	successColor: '#AEFF8A',
	textColor: '#4F5C65',
	secondaryColor: '#979DA6',
	bgDefaultButton: '#FDFDFD',
	borderColor: '#d9d9d9',
	text2Color: '#041E39',
	baseBgColor: '#ffffff',
	mainBgColor: '#ffffff',
	browserThemeColor: '#ffffff',
	screen: {
		small: '480px',
		mobile: '640px',
		tablet: '768px',
		laptop: '970px',
		desktop: '1480px',
		ldesktop: '1680px',
		widescreen: '1920px'
	},
	fontSize: {
		base: 16,
		sm: 5
	}
};

export const DesignConfigDark = Object.assign({}, DesignConfigLight, {
	primaryColor: colors.PRIMARY_DARK_COLOR || colors.PRIMARY_COLOR,
	primaryTint: generateColorSteps(colors.PRIMARY_DARK_COLOR || colors.PRIMARY_COLOR, 9, '#000000'),
	baseBgColor: '#000000',
	mainBgColor: '#0e0e0e',
	bgDefaultButton: '#0e0e0e',
	borderColor: '#2e2d2d',
	text2Color: '#d0d0d0',
	textColor: '#a0a0a0',
	secondaryColor: '#7f7f7f',
	browserThemeColor: '#000000'
});